import api from './api';

export interface GeocodeResult {
  lat: number;
  lng: number;
}

/**
 * Geocodifica via backend (apenas resultados validados).
 * Retorna null se não houver match confiável.
 */
export const geocodeAddress = async (
  endereco: string
): Promise<GeocodeResult | null> => {
  if (!endereco?.trim()) return null;
  try {
    const response = await api.get<{
      success?: boolean;
      result?: { lat: number; lng: number };
    }>(`/geocoding/geocode?q=${encodeURIComponent(endereco.trim())}`);
    const data = response.data;
    if (data.success && data.result?.lat != null && data.result?.lng != null) {
      return {
        lat: Number(data.result.lat),
        lng: Number(data.result.lng),
      };
    }
  } catch (err) {
    console.warn('Geocoding falhou:', err);
  }
  return null;
};

export const resolveDestinoFromFase = async (fase: {
  destino_lat?: number | null;
  destino_lng?: number | null;
  endereco_destino?: string;
}): Promise<GeocodeResult | null> => {
  if (fase.destino_lat != null && fase.destino_lng != null) {
    const lat = Number(fase.destino_lat);
    const lng = Number(fase.destino_lng);
    if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
      return { lat, lng };
    }
  }
  if (fase.endereco_destino?.trim()) {
    return geocodeAddress(fase.endereco_destino.trim());
  }
  return null;
};
